import { render, staticRenderFns } from "./configuration-local-assays-sections-grid.vue?vue&type=template&id=a4e09950&scoped=true&"
import script from "./configuration-local-assays-sections-grid.ts?vue&type=script&lang=ts&"
export * from "./configuration-local-assays-sections-grid.ts?vue&type=script&lang=ts&"
import style0 from "./configuration-local-assays-sections-grid.scss?vue&type=style&index=0&id=a4e09950&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4e09950",
  null
  
)

export default component.exports